import CoursewareTargetProvider from './CoursewareTargetProvider';

export default class CoursewareTargetService {
  createTarget(id) {
    return CoursewareTargetProvider.createCoursewareTarget(id);
  }

  static build() {
    return new CoursewareTargetService();
  }
}
